import React from "react";

import { cn } from "@/utils/cn";

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  title: string;
}

export const HeadTitle = ({ className, title }: Props) => (
  <h1 className={cn("text-[2.5rem] font-normal", className)}>{title}</h1>
);
